import styled from "styled-components";

export const Container = styled.div`
`

export const Wrapper = styled.div`
  .action-popups{
      text-transform: none;
      position: absolute;
      display: grid;
      width: 350px;
      border: 1px solid #DADADA;
      border-radius: 5px;
      top: 47px;
      right: -48px;
      background: #fff;
      z-index: 1;
      margin-bottom: 2px;    
      /* max-height: 200px;
      overflow: auto; */
      div{
          display: flex;
          cursor: pointer;
      }
      span{
          margin: 10px;
      }
      .header{
        padding: 10px 0px 10px 20px;
        border-bottom: 1px solid #DADADA;
        h6{
            color: #111111;
        }
        p{
          border-radius: 50%;
          height: 17px;
          width: 17px;
          font-size: 11px;
          text-align: center;
          background: #4DB114;
          color: #fff;          
          margin: 2px 2px 2px 7px;
        }
      }
      .top-arrow{
          position: absolute;
          width: 15px;
          height: 15px;
          background: #ffff;
          border: solid #DADADA;
          border-width: 1px 0 0 1px;
          transform: rotate(45deg);
          top: -9px;
          right: 63px;
      }
      .content-styles{
        padding: 10px 9px 0px 13px;
        p{
          color: #000000;
        }
        span{
          color: #464646;
          margin: 6px 0 0 0;
        }
        hr{
            height: 0.5px;
            margin: 6px 0px 0px 0px;
        }
      }
      .unread-msg{
        background: #F7F7F7;
      }
    }
`